import { whereOperators } from '@/lib/query-parameter/filter';
import { searchFieldOptionList, storeStatusOptionList, deliveryPayFlagOptionList, } from '@/constants/storeManagement';
const getters = {
    getterPageSize: ({ filterOption }) => Number(filterOption.pageSizeType),
    getterPageSizeType: ({ filterOption }) => filterOption.pageSizeType,
    getterStoreStatusType: ({ filterOption }) => filterOption.storeStatusType,
    getterDeliveryPayFlagType: ({ filterOption }) => filterOption.deliveryPayFlagType,
    getterSearchValue: ({ filterOption }) => filterOption.searchWord.value,
    getterSearchField: ({ filterOption }) => filterOption.searchWord.field,
    getterStoreList: ({ storeList }) => storeList ?? [],
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages, } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    getterStoreTotalLength: ({ paginationData }) => paginationData.total,
    getterSearchFieldTypeParam: ({ filterOption }) => {
        const [NAME, CODE, PHONE,] = searchFieldOptionList;
        const { value, field } = filterOption.searchWord;
        return {
            [NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: NAME.field,
                    value,
                },
            ],
            [CODE.value]: [
                {
                    condition: whereOperators.like,
                    field: CODE.field,
                    value,
                },
            ],
            [PHONE.value]: [
                {
                    condition: whereOperators.like,
                    field: PHONE.field,
                    value,
                },
            ],
        }[field];
    },
    getterStoreStatusTypeParam: ({ filterOption }) => {
        const [ALL, ON, PAUSE, OFF, DELETE,] = storeStatusOptionList;
        const { storeStatusType } = filterOption;
        return {
            [ON.value]: [
                {
                    condition: whereOperators.equals,
                    field: ON.field,
                    value: ON.value,
                },
            ],
            [PAUSE.value]: [
                {
                    condition: whereOperators.equals,
                    field: PAUSE.field,
                    value: PAUSE.value,
                },
            ],
            [OFF.value]: [
                {
                    condition: whereOperators.equals,
                    field: OFF.field,
                    value: OFF.value,
                },
            ],
            [ALL.value]: [
                {
                    condition: whereOperators.notEquals,
                    field: DELETE.field,
                    value: DELETE.value,
                },
            ],
        }[storeStatusType];
    },
    getterDeliveryPayFlagTypeParam: ({ filterOption }) => {
        const [ALL, MONTHLY_CHARGE, MONTHLY_FIXED_AMOUNT, PER_CASE,] = deliveryPayFlagOptionList;
        const { deliveryPayFlagType } = filterOption;
        if (deliveryPayFlagType === ALL.value) {
            return [];
        }
        return {
            [MONTHLY_CHARGE.value]: [
                {
                    condition: whereOperators.equals,
                    field: MONTHLY_CHARGE.field,
                    value: MONTHLY_CHARGE.value,
                },
            ],
            [MONTHLY_FIXED_AMOUNT.value]: [
                {
                    condition: whereOperators.equals,
                    field: MONTHLY_FIXED_AMOUNT.field,
                    value: MONTHLY_FIXED_AMOUNT.value,
                },
            ],
            [PER_CASE.value]: [
                {
                    condition: whereOperators.equals,
                    field: PER_CASE.field,
                    value: PER_CASE.value,
                },
            ],
        }[deliveryPayFlagType];
    },
};
export default getters;
